export default [
    {
        path: '/payment/type/edit/:id',
        name: 'payment_type_edit',
        component: () => import('@src/payment/payment-type/payment-type-edit'),
        props(route) {
            return route.params;
        },
        meta: {
            title: 'Zahlart bearbeiten',
            role: 'ROLE_EDIT_PAYMENT_TYPE',
        },
    },
    {
        path: '/payment/type/list',
        name: 'payment_type_list',
        component: () => import('@src/payment/payment-type/payment-type-overview.vue'),
        meta: {
            title: 'Zahlarten',
            role: 'ROLE_LIST_PAYMENT_TYPE',
        },
    },
];
